// src/components/formatter/marks/ColorMark.js
import { Mark } from 'tiptap'
import { toggleMark } from 'tiptap-commands'

export default class ColorMark extends Mark {
    get name() {
        return 'color'
    }

    get schema() {
        return {
            attrs: {
                color: { default: '#000000' }
            },
            inline: true,
            group: 'inline',
            parseDOM: [
                {
                    style: 'color',
                    getAttrs: color => ({ color })
                }
            ],
            toDOM: mark => ['span', { style: `color: ${mark.attrs.color}` }, 0]
        }
    }

    commands({ type }) {
        return attrs => toggleMark(type, attrs)
    }
}